import { useContext } from "react";

import { ApplicationContext, IApplicationContext } from "../ApplicationContext";

export function useApplication() {
  return useContext<IApplicationContext>(ApplicationContext);
}
